import { createFileRoute } from "@tanstack/react-router";
import { NewProjectWizard } from "@/features/workspace/NewProjectWizard";

export const Route = createFileRoute("/w/$workspace/_ws/projects/new")({
  component: () => {
    const { workspace } = Route.useParams();
    return <NewProjectWizard workspace={workspace} />;
  },
});
